import PostCard from './post/card.js'

document.addEventListener('DOMContentLoaded', function () {
  const postCardsEls = document.querySelectorAll('.post-card')
  postCardsEls.forEach((el) => {
    new PostCard(el)
  })
})

